module.exports = __webpack_public_path__ + "assets/30783a7363388d2d871e379579215c50.png";